import generateWithAsyncActions from 'epic-alt-utils';

import alt from '../alt';

/**
 * WatchActions
 */
export default generateWithAsyncActions(alt, ['sendInvite'], ['showModal', 'hideModal']);
